import { useContext } from "react";
import { useSelector } from "react-redux";
import {
  ProjectStatusCreationError,
  Identifiable,
  ProjectStatus,
} from "@planzone/dto";
import { Boundaries } from "@planzone/core";
import { CoreContext } from "../context";

interface ViewModel {
  isRequestSuccess: boolean;
  isRequestFailure: boolean;
  isRequestPending: boolean;
  error: ProjectStatusCreationError;
  editProjectStatus(request: Boundaries["editProjectStatus"]["request"]): void;
}

function useEditProjectStatus(status: Identifiable<ProjectStatus>): ViewModel {
  const { selector, core } = useContext(CoreContext);

  return {
    isRequestPending: useSelector(() =>
      selector.isEditProjectStatusRequestPending(status),
    ),
    isRequestSuccess: useSelector(() =>
      selector.isEditProjectStatusRequestSuccess(status),
    ),
    isRequestFailure: useSelector(() =>
      selector.isEditProjectStatusRequestFailure(status),
    ),
    error: useSelector(() => selector.getEditProjectStatusError(status)),
    editProjectStatus: core.editProjectStatus,
  };
}

export { useEditProjectStatus };
